<!-- <app-rotation-handler *ngIf="!isLocalizationLoading"> -->
<div *ngIf="!isLocalizationLoading">
  <app-c05-compare-modal *ngIf="isComparisonWindowOpen"></app-c05-compare-modal>
  <router-outlet></router-outlet>
</div>
<!-- </app-rotation-handler> -->
